export const blockIconsBusinessandpaymentsDatabaseNew = (
	<span className='material-symbols-outlined'>database</span>
);
